import dayjs, { Dayjs } from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

type DateParam = string | Dayjs | undefined | null;

export const isDateInRange = (date: DateParam, startDate: DateParam, endDate: DateParam) => dayjs(date).isBetween(startDate, endDate, 'day', '[]');